<template>
    <div class="flex-grow mt-6">
        <div class="pb-1 mb-2 md:mb-5">
            <h3 class="font-medium leading-5 text-gray-900 text-md">
                Suggested Facilities
            </h3>
        </div>
        <div>
            <div
                v-for="(facility) in searchResults"
                :key="facility.id"
                class="flex justify-between mt-1 bg-white border border-gray-200 rounded-lg shadow"
            >
                <a
                    :href="facility.route"
                    class="block transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus:bg-gray-50"
                >
                    <div class="flex items-center px-4 py-4 sm:px-6">
                        <div class="flex items-center flex-1 min-w-0">
                            <div
                                class="flex-1 min-w-0 md:px-4 md:grid md:grid-cols-4 md:gap-4"
                            >
                                <div class="col-span-3 space-y-1">
                                    <div
                                        class="flex space-x-2 text-sm font-semibold leading-5 text-blue-900 truncate hover:text-blue-700 lg:text-md visited:text-indigo-800"
                                    >
                                        <span class="flex-shrink-0 truncate lg:flex-shrink">
                                            {{ facility.name }}
                                        </span>
                                        <span
                                            v-if="facility.npi"
                                            class="items-center px-2 py-0.5 rounded text-xs font-medium leading-4 tracking-wide bg-gray-100 text-gray-800 hidden md:inline-flex"
                                        >
                                            NPI:
                                            {{ facility.npi }}
                                        </span>
                                        <span
                                            v-if="facility.firm_type"
                                            class="items-center px-2 py-0.5 rounded text-xs font-medium leading-4 tracking-wide bg-blue-100 text-blue-800 hidden md:inline-flex"
                                        >
                                            {{ facility.firm_type }}
                                        </span>
                                        <template v-if="facility.idns">
                                        <span
                                            v-for="(idn) in facility.idns"
                                            :key="idn.id"
                                            class="text-sm font-normal text-gray-600 truncate"
                                        >
                                            {{ idn.name }}
                                        </span>
                                        </template>
                                    </div>
                                    <div class="hidden md:block">
                                        <div v-if="facility.networks">
                                            <div
                                                v-for="(network) in facility.networks"
                                                :key="network.id"
                                                class="flex items-center text-sm font-medium leading-5 text-gray-900 truncate"
                                            >
                                                <span
                                                    class="ml-1 font-normal text-gray-500 truncate"
                                                >
                                                    {{ network.name }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        v-if="facility.city_state_edge_ngram"
                                        class="inline-flex items-center text-sm leading-5 text-gray-500 sm:mt-0"
                                    >
                                        <svg
                                            class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                                clip-rule="evenodd"
                                            />
                                        </svg>
                                        <span>
                                            {{ facility.city_state_edge_ngram }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>

                        </div>
                    </div>
                </a>
                <span v-if="inFacilities(facility.id)" class="inline-flex p-2 mr-2">
                    <span class="hidden text-sm md:inline-flex">
                        Added
                    </span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="inline-flex w-5 h-5 ml-1 text-green-600">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                </span>
                <span v-else>
                    <button class="hidden mr-2 tw-button-green md:justify-end md:mr-4 md:block" @click="addToSurgeon(facility.id)">
                        Add
                    </button>
                    <button class="block w-6 h-6 mr-2 text-center bg-green-600 rounded-full hover:bg-green-700 justify-items-center md:hidden" @click="addToSurgeon(facility.id)">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4 text-white">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                        </svg>
                    </button>
                </span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            searchFilters: {
                type: [Array, Object],
                required: true,
            },
            searchRoute: {
                type: String,
                required: true,
            },
            model: {
                type: [Array, Object],
                required: true,
            },
            facilities: {
                type: [Array, Object],
                required: false,
            }
        },
        created() {
            this.loadItems();
        },
        data () {
            return {
                searchResults: {},
                serverParams: {
                    searchTerm: '',
                    filters: {},
                    pageSize: 10,
                    page: 0,
                },
                total: 0,
            }
        },
        methods: {
            async loadItems() {
                this.serverParams.filters = this.searchFilters;
                try {
                    const response = await axios.get(this.searchRoute, { params: this.serverParams });
                    this.searchResults = response.data.results;
                    this.total = response.data.totalRows;
                    this.isLoading = false;

                } catch (error) {
                    this.rows = [];
                    this.isLoading = false;
                    return false;
                }

                return true;
            },
            addToSurgeon(facility_id) {
                this.$emit('add-to-surgeon', facility_id);
            },
            inFacilities(facility_id) {
                if (this.facilities.length > 0) {
                    let ids = this.facilities.map(a => a.id)
                    return ids.includes(facility_id);
                }
                return false;
            }
        }
    }
</script>
